import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // Check localStorage for preferred theme, default to 'dark'
    const [theme, setTheme] = useState(() => {
        const storedTheme = localStorage.getItem('app-theme');
        return storedTheme ? storedTheme : 'dark';
    });

    useEffect(() => {
        // Automatically save theme to localStorage
        localStorage.setItem('app-theme', theme);

        // Update the document level data-theme attribute
        if (theme === 'ozyurek') {
            document.documentElement.setAttribute('data-theme', 'ozyurek');
        } else {
            document.documentElement.removeAttribute('data-theme');
        }
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'dark' ? 'ozyurek' : 'dark'));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
